import React from "react";
import classNames from "classnames/bind";
import Styles from "./Footer.module.scss";
import Image from "../../components/Image/Image";
import { MdOutlineEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import images from "../../assets/images/images";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(Styles);

const Footer = () => {
  const { t } = useTranslation();

  return (
    <></>
    // <div className={cx("wrapper")}>
    //   <div className={cx("contact")}>
    //     <span className={cx("contact-title")}>
    //       {t("contact_us").charAt(0).toUpperCase() + t("contact_us").slice(1)}
    //     </span>
    //   </div>

    //   <div className={cx("desc")}>
    //     <div className={cx("desc-item")}>
    //       <p className={cx("footer-desc")}>{t("developed_by")}</p>
    //       <div className={cx("logo-imgs")}>
    //         <Image
    //           src={images.ATLogo}
    //           alt="AT Logo"
    //           className={cx("logo-item")}
    //         />
    //         <Image
    //           src={images.hekateLogo}
    //           alt="Hekate Logo"
    //           className={cx("logo-item")}
    //         />
    //       </div>
    //     </div>

    //     <div className={cx("desc-item")}>
    //       <p className={cx("footer-desc")}>{t("support_from")}</p>

    //       <div className={cx("logo-imgs")}>
    //         <Image
    //           src={images.BY}
    //           alt="Sanar Logo"
    //           className={cx("logo-item-laos")}
    //         />
    //         <Image
    //           src={images.EU}
    //           alt="Sanar Logo"
    //           className={cx("logo-item-eu")}
    //         />
    //         <Image
    //           src={images.unicef}
    //           alt="Sanar Logo"
    //           className={cx("logo-item-unicef")}
    //         />
    //       </div>
    //     </div>
    //   </div>
    //   <div className={cx("right")}>
    //     <span className={cx("footer-text")}>
    //       {t("footer_text")}
    //     </span>
    //   </div>
    // </div>
  );
};

export default Footer;
